import { render, staticRenderFns } from "./CollectPeripheralTable.vue?vue&type=template&id=5172963d"
import script from "./CollectPeripheralTable.vue?vue&type=script&lang=js"
export * from "./CollectPeripheralTable.vue?vue&type=script&lang=js"
import style0 from "./CollectPeripheralTable.vue?vue&type=style&index=0&id=5172963d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports